// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DragEndEvent } from '@dnd-kit/core';

// Components
import { StyledContentBlock, StyledPageWrapper } from '../Styled';
import { useGetProductsOfMonthTableColumns } from './columns';
import { DraggableTable } from '@/components';

// Models
import { ITopProduct } from '@/models/products.model';

type TTopProductsList = {
  isLoading: boolean;
  productsList: ITopProduct[] | null;
  handleDragEnd?: (event: DragEndEvent) => Promise<void>;
  setProductForDelete: (product: ITopProduct) => void;
  handleEditClick: (product: ITopProduct) => void;
  canManageTopProduct: boolean;
};

const TopProductsList = ({
  isLoading,
  productsList,
  handleDragEnd,
  setProductForDelete,
  canManageTopProduct,
}: TTopProductsList) => {
  const { t } = useTranslation(['products']);
  const columns = useGetProductsOfMonthTableColumns({
    t,
    setProductForDelete,
    canManageTopProduct,
  });

  return (
    <StyledPageWrapper>
      <StyledContentBlock>
        <DraggableTable
          columns={columns}
          dataSource={productsList || []}
          rowKey="id"
          loading={isLoading}
          onDragEnd={handleDragEnd}
        />
      </StyledContentBlock>
    </StyledPageWrapper>
  );
};

export default TopProductsList;
